import home from './sv/home';
import settings from './sv/settings';
import HomePage from './sv/HomePage';
import MinLivesStilHeader from './sv/MinLivesStilHeader';
import WelcomePage from './sv/WelcomePage';
import LoginPage from './sv/LoginPage';
import navigation from './sv/navigation';
import goals from './sv/goals';
import lifestyle from './sv/lifestyle';
import work from './sv/work';

export default {
  home: home,
  settings: settings,
  HomePage: HomePage,
  MinLivesStilHeader: MinLivesStilHeader,
  WelcomePage: WelcomePage,
  LoginPage: LoginPage,
  navigation: navigation,
  goals: goals,
  lifestyle: lifestyle,
  work: work,
  aiChat: {
    guided: {
      question: 'Fråga',
      startInstruction: 'Klicka nu på Fråga 1 nedan så ska jag svara dig utifrån all samlad kunskap jag kan hitta.',
      goalStatement: 'Mitt mål är att {goals}. Jag behöver hjälp med detta.',
      priorityPrompt: 'Vill du att jag hjälper dig att prioritera vad du ska göra?',
      planPrompt: 'Vill du att jag skapar en konkret Livsstilsplan åt dig?',
      yes: 'Ja tack',
      no: 'Nej tack',
      priorityYesMessage: 'Ja tack, hjälp mig att prioritera vad jag ska göra.',
      priorityNoMessage: 'Nej tack, jag vill inte ha hjälp att prioritera just nu.',
      planYesMessage: 'Ja tack, skapa en konkret Livsstilsplan åt mig.',
      planNoMessage: 'Nej tack, skapa ingen Livsstilsplan just nu.',
      finish: 'Avsluta',
      thanks: 'Tack så mycket. Nu ska jag sätta igång att genomföra min Livsstilsplan.',
      declinedThanks: 'Tack för hjälpen. Jag avslutar samtalet här.',
    },
  },
  welcome: `Välkommen!
Kul att du ska testa Bwell-metoden.
Lycka till!`,
  start: 'Sätt igång',
  emailLabel: 'E-post:',
  passwordLabel: 'Lösenord:',
  login: 'Logga in',
  emailRequired: 'Ange din e-postadress.',
  emailInvalid: 'Ogiltigt e-postformat',
  passwordRequired: 'Ange ditt lösenord.',
  invalidCredentialsTitle: 'Ogiltiga inloggningsuppgifter',
  invalidCredentialsMessage:
    'Ingen användare med de inloggningsuppgifterna hittades.',
  noInternetTitle: 'Ingen internetuppkoppling',
  noInternetMessage: 'Det verkar som att du saknar en internetuppkoppling.',
  serverErrorTitle: 'Kunde inte ansluta till servern',
  serverErrorMessage:
    'Kontrollera att du har en internetuppkoppling och försök igen senare',
  unknownErrorTitle: 'Ett okänt fel har uppstått',
  unknownErrorMessage:
    'Försök igen senare. Kontakta supporten om felet kvarstår',
  privacyPolicy: 'Läs vår integritetspolicy',
  forgotPassword: 'Glömt lösenord?',
  workMessage1: 'Bwell ger dig som anställd en personlig Livsstilsplan.',
  workMessage2:
    'Och hjälper dig att bestämma hur du vill ha ditt fysiska, mentala och sociala liv framöver. Sånt som är viktigt för att kunna må bra!',
  featureNotAvailable: 'Det här är inte tillgängligt i denna testversion.',
  select: 'VÄLJ',
  stopNow: 'Stopp nu!',
  youHaveNotAnswered: 'Du har inte svarat på frågan.',
  youHaveNotAnsweredSatisfaction: 'Du har inte svarat om du är nöjd eller vill förbättra.',
  continueAnyway: 'Gå vidare ändå',
  close: 'Stäng'
};
